import {Inject, Injectable} from '@angular/core';

@Injectable()
export class LocalStorageService {

    private static readonly PREFIX = 'configurator_storage_';
    storage: Storage;

    constructor() {
        this.storage = (window as WindowLocalStorage).localStorage as Storage;
    }

    getItem(key: string, defaultValue?: any) {
        let item = this.storage.getItem(LocalStorageService.PREFIX + key);
        if (!item) {
            return defaultValue;
        } else {
            item = JSON.parse(atob(item));
            if (item) {
                return item;
            }
        }
        return defaultValue;
    }

    putItem(key: string, value: any) {
        this.storage.setItem(LocalStorageService.PREFIX + key, btoa(JSON.stringify(value)));
    }

    removeItem(key) {
        this.storage.removeItem(LocalStorageService.PREFIX + key);
    }

}



// WEBPACK FOOTER //
// ./src/app/common/services/localStorage.service.ts